import { render, staticRenderFns } from "./Pages.vue?vue&type=template&id=2d67c38b&"
import script from "./Pages.vue?vue&type=script&lang=js&"
export * from "./Pages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports